
import { Helmet } from "react-helmet";

import MainLayout from "@/components/layout/MainLayout";
import TestimonialsUpdated from "@/components/TestimonialsUpdated";
import BackButton from "@/components/common/BackButton";

const TestimonialsPage = () => {
  return (
    <>
      <Helmet>
        <title>Opinie Detailing Poznań Wilda ★★★★★ 5.0/5 | 061 Garage</title>
        <meta 
          name="description" 
          content="Przeczytaj opinie o 061 Garage Poznań Wilda ★★★★★ 5.0/5! Zadowoleni klienci polecają nasze usługi detailingu. Umów się: 602 709 327" 
        />
        <meta name="keywords" content="opinie detailing Poznań Wilda, recenzje 061 garage, zadowoleni klienci detailing, oceny detailing Poznań, opinie o myciu aut" />
        <link rel="canonical" href="https://061garagedetailingstudio.pl/opinie" />
        <meta property="og:title" content="Opinie Detailing Poznań Wilda ★★★★★ 5.0/5 | 061 Garage" />
        <meta property="og:description" content="Sprawdź opinie zadowolonych klientów ★★★★★ 5.0/5! Profesjonalny detailing Poznań Wilda. Zadzwoń: 602 709 327" />
        <meta property="og:url" content="https://061garagedetailingstudio.pl/opinie" />
        <meta property="og:image" content="https://061garagedetailingstudio.pl/lovable-uploads/5f17a190-693b-4d81-b673-957c3b473247.png" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pl_PL" />
        <meta property="og:site_name" content="061 Garage Detailing Studio" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Opinie Detailing Poznań Wilda ★★★★★ 5.0/5 | 061 Garage" />
        <meta name="twitter:description" content="Sprawdź opinie zadowolonych klientów ★★★★★ 5.0/5! Profesjonalny detailing Poznań Wilda. Zadzwoń: 602 709 327" />
        <meta name="twitter:image" content="https://061garagedetailingstudio.pl/lovable-uploads/5f17a190-693b-4d81-b673-957c3b473247.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ReviewPage",
            "name": "Opinie klientów 061 Garage Detailing Studio",
            "description": "Recenzje i opinie o usługach detailingu samochodowego",
            "reviewedBy": {
              "@type": "LocalBusiness",
              "name": "061 Garage Detailing Studio"
            }
          })}
        </script>
      </Helmet>
      <BackButton />
      <MainLayout>
        <div className="pt-24 md:pt-28">
          <TestimonialsUpdated />
        </div>
      </MainLayout>
    </>
  );
};

export default TestimonialsPage;
